export const allowedUserEmailIds = [
  'dgm.admin@universal.edu.in',
  'gm.co@universal.edu.in',
  'coo@universal.edu.in',
  'shreyas@technogise.com',
  'stellar@universal.edu.in',
  'pinky@universal.edu.in',
  'vivek+parent1@technogise.com',
  'gaurav.rai+uahm@universal.edu.in',
  'tharuneswar.d+admin@joinether.in',
  'pravin.shukla+admin@joinether.in',
  'mohammed.hussain+admin@joinether.in',
  'karthik.nr+admin@joinether.in',
  'obaid+admin@joinether.in',
  'gaurav.rai+uht@universal.edu.in',
  'varsha.jayashankar+uahm@universal.edu.in',
  'varsha.jayashankar+uht@universal.edu.in',
  'sankar+uahm@joinether.in',
  'mahesh.khairnar+admin@universal.edu.in',
  'gaurav+ab@joinether.in',
  'gaurav+acis@joinether.in',
  'gaurav+apm@joinether.in',
  'gaurav+awv@joinether.in',
  'gaurav+eisb@joinether.in',
  'gaurav+eisn@joinether.in',
  'gaurav+ihs@joinether.in',
  'gaurav+local@joinether.in',
  'gaurav+ppsb@joinether.in',
  'gaurav+sju@joinether.in',
  'gaurav+sous@joinether.in',
  'gaurav+sws-a@joinether.in',
  'gaurav+sws-b@joinether.in',
  'gaurav+sws-g@joinether.in',
  'gaurav+uahm@joinether.in',
  'gaurav+uhd@joinether.in',
  'gaurav+uhm@joinether.in',
  'gaurav+uhsa@joinether.in',
  'gaurav+uhsc@joinether.in',
  'gaurav+uht@joinether.in',
  'gaurav+usg@joinether.in',
  'gaurav+ust@joinether.in',
  'sankar+ab@joinether.in',
  'sankar+acis@joinether.in',
  'sankar+apm@joinether.in',
  'sankar+awv@joinether.in',
  'sankar+eisb@joinether.in',
  'sankar+eisn@joinether.in',
  'sankar+ihs@joinether.in',
  'sankar+local@joinether.in',
  'sankar+ppsb@joinether.in',
  'sankar+sju@joinether.in',
  'sankar+sous@joinether.in',
  'sankar+sws-a@joinether.in',
  'sankar+sws-b@joinether.in',
  'sankar+sws-g@joinether.in',
  'sankar+uahm@joinether.in',
  'sankar+uhd@joinether.in',
  'sankar+uhm@joinether.in',
  'sankar+uhsa@joinether.in',
  'sankar+uhsc@joinether.in',
  'sankar+uht@joinether.in',
  'sankar+usg@joinether.in',
  'sankar+ust@joinether.in',
  'varsha+ab@joinether.in',
  'varsha+acis@joinether.in',
  'varsha+apm@joinether.in',
  'varsha+awv@joinether.in',
  'varsha+eisb@joinether.in',
  'varsha+eisn@joinether.in',
  'varsha+ihs@joinether.in',
  'varsha+local@joinether.in',
  'varsha+ppsb@joinether.in',
  'varsha+sju@joinether.in',
  'varsha+sous@joinether.in',
  'varsha+sws-a@joinether.in',
  'varsha+sws-b@joinether.in',
  'varsha+sws-g@joinether.in',
  'varsha+uahm@joinether.in',
  'varsha+uhd@joinether.in',
  'varsha+uhm@joinether.in',
  'varsha+uhsa@joinether.in',
  'varsha+uhsc@joinether.in',
  'varsha+uht@joinether.in',
  'varsha+usg@joinether.in',
  'varsha+ust@joinether.in',
  'bhoomi+admin@joinether.in',
  'ekta+admin@joinether.in',
  'chetana.govekar+ab@universal.edu.in',
  'chetana.govekar+acis@universal.edu.in',
  'chetana.govekar+apm@universal.edu.in',
  'chetana.govekar+awv@universal.edu.in',
  'chetana.govekar+eisb@universal.edu.in',
  'chetana.govekar+eisn@universal.edu.in',
  'chetana.govekar+ihs@universal.edu.in',
  'chetana.govekar+ppsb@universal.edu.in',
  'chetana.govekar+sju@universal.edu.in',
  'chetana.govekar+sous@universal.edu.in',
  'chetana.govekar+sws-andheri@universal.edu.in',
  'chetana.govekar+sws-bandra@universal.edu.in',
  'chetana.govekar+sws-goregaon@universal.edu.in',
  'chetana.govekar+uahm@universal.edu.in',
  'chetana.govekar+uhd@universal.edu.in',
  'chetana.govekar+uhm@universal.edu.in',
  'chetana.govekar+uhsa@universal.edu.in',
  'chetana.govekar+uhsc@universal.edu.in',
  'chetana.govekar+uht@universal.edu.in',
  'chetana.govekar+usg@universal.edu.in',
  'chetana.govekar+ust@universal.edu.in',
  'varsha+bpis@joinether.in',
  'gaurav+bpis@joinether.in',
  'santosh+bpis@joinether.in',
  'dipika.b+local@joinether.in',
  'jay.sharma+demo4-admin@joinether.in',
  'bhoomi+demo4-admin@joinether.in',
  'satish.wv@gmail.com',
  'abhilashhp.1991+admin@gmail.com',
  'manjusha.bpis@gmail.com',
  'nupoor2905@gmail.com',
  'principal@bpismumbai.com'
];
